import { Chip } from '@mui/material'

export function StatusChip({ on, onLabel, offLabel, loading, onClick }) {
	return (
		<Chip
			label={on ? onLabel : offLabel}
			size="small"
			color={on ? 'success' : 'default'}
			onClick={onClick}
			disabled={loading}
			sx={{ cursor: onClick ? 'pointer' : 'default', fontWeight: 500 }}
		/>
	)
}
